import { render, staticRenderFns } from "./PretrainingThankYou.vue?vue&type=template&id=db78acc2&"
import script from "./PretrainingThankYou.vue?vue&type=script&lang=js&"
export * from "./PretrainingThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports